export default ({ COLORS, FONT_SIZES }) => ({
  container: {
    textAlign: 'center',
    backgroundColor: '#F8F8F8',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '58px 20px 24px',
    borderBottom: '1px solid #ececec',
    '& p': {
      margin: '0 0 10px'
    },
    '& a': {
      color: COLORS.BLUE.NORMAL,
      fontWeight: 'bold',
      textDecoration: 'none'
    }
  },
  noBorder: {
    border: 'none'
  },
  first: {
    borderRadius: '10px 10px 0 0'
  },
  last: {
    borderRadius: '0 0 10px 10px',
    border: 'none'
  },
  thanks: {
    borderRadius: '0 0 10px 10px'
  },
  smallFont: {
    ...FONT_SIZES.BODY_DEFAULT.STYLE
  },
  title: {
    fontSize: '24px',
    lineHeight: '28px',
    margin: '0 0 10px'
  }
})
